import { compactCurrencyFormat, currencyFormat } from "@lib/text.helpers";

export const SOCIAL_AND_MEDICARE_PERCENTAGE = 0.07;

export const FEDERAL_TAX_BRACKETS = [
  { threshold: 0, percentage: 0.11 },
  { threshold: 50_000, percentage: 0.15 },
  { threshold: 100_000, percentage: 0.17 },
  { threshold: 150_000, percentage: 0.2 },
].map((bracket, i, arr) => {
  const nextBracket = arr.length > i + 1 ? arr[i + 1] : undefined;
  const maximumValue = nextBracket?.threshold;

  let labelSuffix = "+";
  let shortLabelSuffix = "+";

  if (maximumValue) {
    shortLabelSuffix = " - " + compactCurrencyFormat(maximumValue - 1000);
    labelSuffix = " - " + currencyFormat(maximumValue - 1);
  }

  return {
    ...bracket,
    shortLabel: `${compactCurrencyFormat(bracket.threshold)}${shortLabelSuffix}`,
    label: `${currencyFormat(bracket.threshold)}${labelSuffix}`,
  };
});

export const getFederalTaxBracket = (annualIncome) => {
  // Reverse brackets to find from higher to lower range
  const bracketsReversed = [...FEDERAL_TAX_BRACKETS].reverse();
  return bracketsReversed.find((b) => annualIncome >= b.threshold);
};

export const calculateTaxedIncome = (annualIncome, regionalIncomeTaxRate) => {
  if (!annualIncome) {
    return { combinedTaxRate: 0, totalTaxDeduction: 0, netIncome: 0 };
  }

  const federalIncomeTax = getFederalTaxBracket(annualIncome);

  const combinedTaxRate =
    federalIncomeTax.percentage +
    (regionalIncomeTaxRate?.averageTaxRate ?? 0) +
    SOCIAL_AND_MEDICARE_PERCENTAGE;

  const totalTaxDeduction = annualIncome * combinedTaxRate;
  const netIncome = annualIncome - totalTaxDeduction;

  return {
    combinedTaxRate,
    totalTaxDeduction,
    netIncome,
  };
};

export const getAnnualIncome = ({ regional, national }) => {
  const annualEarnings = regional
    ? regional.earnings?.annual
    : national.earnings?.annual;

  const annualIncome = annualEarnings?.find(
    (d) => d.percentile == 50,
  )?.earnings;

  return annualEarnings ? Math.round(annualIncome) : 0;
};
